import { render, staticRenderFns } from "./TuneChatbot.vue?vue&type=template&id=2f3926b8&scoped=true"
import script from "./TuneChatbot.vue?vue&type=script&lang=js"
export * from "./TuneChatbot.vue?vue&type=script&lang=js"
import style0 from "./TuneChatbot.vue?vue&type=style&index=0&id=2f3926b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3926b8",
  null
  
)

export default component.exports